module.exports = __webpack_public_path__ + "img/home-bg5.89609671.png";